import { ChangeEvent, Fragment } from "react";
import {
  Box,
  Checkbox,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  useTheme,
} from "@mui/material";
import LocalActivityFilled from "@mui/icons-material/LocalActivity";
import { RoadmapDto, RoadmapItemDto } from "@lib/ShiOneClient";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
import { initialRoadmapItemState } from "shared-ui/src/features/roadmaps-feature/utils/roadmapProps";

const SendToDialogInitiativesView = ({
  selectedRoadmap,
  selectedInitiative,
  handleInitiativeClick,
  handleChangeNewInitiativeName,
}: {
  selectedRoadmap: RoadmapDto | null;
  selectedInitiative: RoadmapItemDto | null;
  handleInitiativeClick: (initiative: RoadmapItemDto | null) => void;
  handleChangeNewInitiativeName: (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => void;
}) => {
  const theme = useTheme();
  const initiatives = selectedRoadmap?.roadmapItems?.filter(
    (roadmapItem) => roadmapItem.parentRoadmapItem === undefined,
  );
  return (
    <List>
      {initiatives?.map((initiative) => {
        return (
          <Fragment key={initiative.roadmapItemId}>
            <ListItem>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                padding={1}
              >
                <Grid item xs display="flex" alignItems="center" gap={1}>
                  <Checkbox
                    checked={
                      selectedInitiative?.roadmapItemId ===
                      initiative.roadmapItemId
                    }
                    onClick={() => handleInitiativeClick(initiative)}
                  />
                  <ListItemIcon sx={{ minWidth: "auto" }}>
                    <LocalActivityFilled />
                  </ListItemIcon>
                  <ListItemText primary={initiative.name} />
                </Grid>
                {initiative.isMilestone && (
                  <Box display="flex" alignItems="center">
                    <SquareRoundedIcon
                      fontSize="small"
                      sx={{
                        transform: "rotate(45deg)",
                        color: theme.palette.table.border,
                      }}
                    />
                  </Box>
                )}
              </Grid>
            </ListItem>
            <Divider />
          </Fragment>
        );
      })}
      <ListItem>
        <Grid
          container
          padding={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Checkbox
              checked={selectedInitiative?.roadmapItemId === "0"}
              onClick={() => {
                handleInitiativeClick({
                  ...initialRoadmapItemState,
                  roadmapItemId: "0",
                } as RoadmapItemDto);
              }}
            />
          </Grid>
          <Grid item xs>
            <TextField
              fullWidth
              placeholder="Create new initiative and add recommendations as task"
              variant="outlined"
              size="small"
              value={selectedInitiative?.name}
              onChange={handleChangeNewInitiativeName}
            />
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
};

export default SendToDialogInitiativesView;
